'use client';
import { useState, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useClickAway } from '@uidotdev/usehooks';
import debounce from 'lodash/debounce';
import { useOnClickOutside } from 'usehooks-ts';
import { objectToQueryString } from '@/shared/libs/query-string';
import {
  SearchInput,
  InputWrapper,
  ImageElement,
  ImageElementWrapper,
} from './styles';
import { useRouter } from 'next-nprogress-bar';
import { Image } from '@/shared/ui/image';

import { useI18n } from '@locales/client';
const SearchGame = ({
  mobileLandscape,
  focused,
  setFocused,
  setSearchFocused,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = searchParams.entries();
  const searchParam = searchParams.get('search');
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState(searchParam);
  const mobileInputRef = useClickAway(() => {
    setFocused && setFocused(false);
  });
  const t = useI18n();

  const outsideRef = useRef(null);
  const inputFocusRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    setSearchFocused && setSearchFocused(false);
  });

  useEffect(() => {
    const updateSearch = () => {
      const currentQueryParams = { ...Object.fromEntries(params) };
      if (searchValue !== null) {
        const queryString = objectToQueryString({
          ...currentQueryParams,
          search: searchValue,
        });
        const newUrl = `${pathname}?${queryString}`;
        router.push(newUrl);
      }
      if (searchValue === null) {
        delete currentQueryParams.search;
        const queryString = objectToQueryString({ ...currentQueryParams });
        const newUrl = `${pathname}?${queryString}`;
        router.push(newUrl);
      }

      if (clearSearch) {
        setFocused(false);
      }
    };

    const debouncedUpdateSearch = debounce(updateSearch, 300);

    debouncedUpdateSearch();

    return () => {
      debouncedUpdateSearch.cancel();
    };
  }, [searchValue, clearSearch]);

  useEffect(() => {
    if (searchParam === null) {
      setSearchValue(null);
    }
  }, [searchParam]);

  const handleChange = (event) => {
    if (event.target.value === '') {
      setSearchValue(null);
    } else {
      setSearchValue(event.target.value);
    }
  };

  return (
    <InputWrapper ref={outsideRef} $focused={focused}>
      <SearchInput
        $focused={focused}
        $searchValue={searchValue}
        value={searchValue ?? ''}
        onFocus={(event) => {
          setFocused && setFocused(true);
        }}
        name="search"
        placeholder={t('common.filter.label.search')}
        onChange={handleChange}
        type="text"
        autoFocus={focused}
        onClick={() => inputFocusRef.current.focus()}
        ref={inputFocusRef}
      />
      {searchValue && (
        <ImageElementWrapper
          onClick={(event) => {
            router.push('/games');
            setSearchFocused && setSearchFocused(false);
          }}
        >
          <ImageElement
            $focused={focused}
            alt="clear"
            width={24}
            height={24}
            src="/images/icons/clear-text-icon.svg"
          />
        </ImageElementWrapper>
      )}
    </InputWrapper>
  );
};

export { SearchGame };
